import { specialCharactersRegex } from 'src/app/modules/shared/regex-pattern';

export class Constants {
  // FE page redirects
  public static readonly personalInfoRoute = '/register/personal-information';
  public static readonly completeDetailsRoute = '/register/complete-details';
  public static readonly activateAccountRoute = '/register/activate-account';
  public static readonly setupMfaRoute = '/setup-mfa';

  // Registration endpoints
  public static readonly saveOrgUrl = '/api/organizations/select-org/[selectedOrgHere]';
  public static readonly signUpUrl = '/manage/accounts/v3/signup';
  public static readonly itSignUpUrl = '/manage/accounts/v3/it-signup';
  public static readonly globalSignUpUrl = '/manage/accounts/v3/global-signup';
  public static readonly completeProfileUrl = '/manage/accounts/v3/complete-profile';
  public static readonly itCompleteProfileUrl = '/manage/accounts/v3/it-complete-profile';

  public static readonly getMigratedRelatedInfo = '/GetMigratedRelatedInfo';

  // Fiscal code
  public static readonly getFiscalCodeDetailsUrl = '/manage/accounts/GetFiscalDetails';

  // Profile
  public static readonly getProfileAnonymously = '/v2/it/manage/accounts/complete-profile-get';

  // Email activation
  public static readonly resendEmailActivationUrl =
    '/manage/accounts/v3/resend_invitation/{base64UserId}';

  public static readonly isFromBookingRedirectUrl =
    '/redirect-for-booking?username=[email]&userid=[userId]&fromPrivateComplete=[fromPrivateComplete]&from-booking=[from-booking]';
  public static readonly itIsFromBookingRedirectUrl =
    '/it-redirect-for-booking?username=[email]&userid=[userId]&fromPrivateComplete=[fromPrivateComplete]&from-booking=[from-booking]';

  public static readonly itSearchPostalCodeByCity =
    '/v2/manage/accounts/postal-codes-by-description?description=[city-name]';
}

export const PasswordValidations: { validator: (password: string) => boolean; label: string }[] = [
  {
    validator: (password: string) => password.length >= 8,
    label: 'passwordValidation1',
  },
  {
    validator: (password: string) => {
      const specialCharacters = specialCharactersRegex;
      return specialCharacters.test(password);
    },
    label: 'passwordValidation2',
  },
  {
    validator: (password: string) => {
      const capitalLetter = /[A-Z]/;
      return capitalLetter.test(password);
    },
    label: 'passwordValidation3',
  },
  {
    validator: (password: string) => {
      const lowercaseLetter = /[a-z]/;
      return lowercaseLetter.test(password);
    },
    label: 'passwordValidation4',
  },
  {
    validator: (password: string) => {
      const number = /[0-9]/;
      return number.test(password);
    },
    label: 'passwordValidation5',
  },
];
